import { Grid } from '@material-ui/core';
import { Button, CurrencyField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { delinquencyService } from '../delinquencyService';

export type RealizedLossFormData = {
  realizedInterestLoss: number | string;
  realizedPrincipalLoss: number | string;
};

export type RealizedLossFormProps = {
  handleClose: () => void;
  loanId?: number;
  onSave?: (data: RealizedLossFormData) => void | Promise<void>;
};

export const RealizedLossForm = observer(
  ({ handleClose, loanId, onSave }: RealizedLossFormProps) => {
    const [realizedInterestLoss, setRealizedInterestLoss] = useState<number | string>('');
    const [realizedPrincipalLoss, setRealizedPrincipalLoss] = useState<number | string>('');

    const handleSave = async () => {
      const data = { realizedInterestLoss, realizedPrincipalLoss };
      if (loanId != null) {
        await delinquencyService.setRealizedPrincipalAndInterestLoss({
          loanId,
          interestLoss: Number(realizedInterestLoss) || 0,
          principalLoss: Number(realizedPrincipalLoss) || 0,
        });
      }
      if (onSave) {
        await onSave(data);
      }
      handleClose();
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CurrencyField
            label="Realized Interest Loss"
            name="realizedInterestLoss"
            value={realizedInterestLoss}
            onChange={(_, value) => setRealizedInterestLoss(value)}
            fullWidth
            variant="outlined"
            testId="realized-loss-interest"
          />
        </Grid>
        <Grid item xs={12}>
          <CurrencyField
            label="Realized Principal Loss"
            name="realizedPrincipalLoss"
            value={realizedPrincipalLoss}
            onChange={(_, value) => setRealizedPrincipalLoss(value)}
            fullWidth
            variant="outlined"
            testId="realized-loss-principal"
          />
        </Grid>
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <Button
              type="button"
              variant="contained"
              color="default"
              testId="realized-loss-cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="button"
              variant="contained"
              color="primary"
              testId="realized-loss-save"
              onClick={handleSave}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
);
